import { DBLogger } from '@app/anylogger'
import { ClientProxy } from '@app/clientserverutils'
import { useModal } from '@app/muiplus'
import { formatDateTime } from '@app/utils'
import { Button, ButtonOwnProps, ButtonPropsSizeOverrides } from '@mui/material'
import { useCallback, useState } from 'react'
import { useSession } from 'src/services/useSession'
import { IWebEditorApi } from 'src/services/WebEditor/IWebEditorApi'
import anylogger from '@app/anylogger'
import JSZip from 'jszip'
import { OverridableStringUnion } from '@mui/types'

const log = anylogger('SendErrorReport')

export async function sendDebugEmail(user: string, email?: string, prefix: string = '') {
	if (!user) user = 'Unknown User'
	if (!email) email = 'Unknown Email'

	const api = new ClientProxy(new IWebEditorApi(), '/api/webEditor') as IWebEditorApi
	const logger = new DBLogger()
	const logs = await logger.getRecordsForDate(new Date())
	if (!logs || !logs.length) {
		log('No logs found for user', user)
		return
	}
	const startIdx = Math.max(logs.length - 200, 0)
	const recentLogs = logs.slice(startIdx)
	const logStr = JSON.stringify(recentLogs)

	if (prefix) prefix = prefix + ' '
	else prefix = 'Logs '
	const zip = new JSZip()
	zip.file(`${prefix}${formatDateTime(new Date(), 'yyyy-mm-dd hhnn')} - ${user}.log`, logStr)

	const content = await zip.generateAsync({ type: 'base64' })

	await api.sendEmail('webmaster@kc7070.ca', email, `${prefix} file from ${user}`, `${prefix} File from ${user} - ${email}`, [
		{ filename: `${prefix}${formatDateTime(new Date(), 'yyyy-mm-dd hhnn')} - ${user}.zip`, content, encoding: 'base64' }
	])
}

interface SendErrorReportProps {
	size?: OverridableStringUnion<'small' | 'medium' | 'large', ButtonPropsSizeOverrides>
}
function SendErrorReport(props: SendErrorReportProps) {
	const { size = 'medium' } = props

	const [session, loading] = useSession()
	const email = session?.user?.email
	const name = session?.user?.name
	const { alertDialog, busyDialog } = useModal()
	const sendDebugLog = useCallback(async () => {
		const { cancel } = busyDialog({ title: 'Sending Debug Email', content: 'Sending...' })

		try {
			await sendDebugEmail(name || '', email || '', 'Error')
			await cancel()
			alertDialog({
				title: 'Email Sent',
				content: 'The email was sent successfully.'
			})
		} catch (err) {
			log('Error sending debug email', err)
			await cancel()
			alertDialog({
				title: 'Error Sending Debug Email',
				content: JSON.stringify(err)
			})
		}
	}, [alertDialog, busyDialog, email, name])

	return (
		<Button
			onClick={sendDebugLog}
			size={size}
			sx={{
				mx: 'auto"'
			}}
		>
			Send Error Report
		</Button>
	)
}
export default SendErrorReport
